<template>
  <div
    class="all_help"
    :class="{
      'background_image': showBackground,
      'top_tip_show': topTipShow && showBackground,
    }">
    <div
      class="base_back_btn"
      v-show="showBackground"
      @click="$router.go(-1)"
      :class="{'base_back_btn_down': topTipShow}">
      <span>返回</span>
    </div>
    <div class="like_tip" v-show="showBackground" :class="{'like_tip_hide': !topTipShow}">
      <div class="like_tip_title">您还有<span>{{ giveLikeCount }}</span>次，给他人点赞的机会哦~</div>
      <img src="@/assets/help-activity/top_close@2x.png" @click="handleCloseTopTip" />
    </div>
    <header>
      <img src="@/assets/help-activity/icon1@2x.png" alt="" />
      <div>参赛作品集锦</div>
    </header>
    <div class="all_help_container">
      <van-list
        v-if="manifestoList.length"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        offset="3"
        @load="onLoad"
        :immediate-check="false"
      >
        <div
          v-for="(item, index) in manifestoList"
          :key="index"
          class="all_help_item"
        >
          <HelpItem
            :data="item"
            :giveLikeCount="giveLikeCount"
            @hasLike="hasLike"
            @hasNotLikeNum="hasNotLikeNum"
          />
        </div>
      </van-list>
    </div>
    <van-popup v-model="noLikeNumDialog" class="no_like_num_dialog" get-container="#app">
      <div class="no_like_num_dialog_container">
        <img class="no_like_num" src="@/assets/help-activity/like_fail@2x.png" />
        <div class="no_like_num_btn" @click="noLikeNumDialog = false"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import HelpItem from "./components/HelpItem";
import {
  listCompetitionWorks,
  getTaskInfoById,
} from "@/api";
export default {
  props: {
    showBackground: {
      type: Boolean,
      default: true
    },
    fatherGiveLikeCount: {
      type: Number,
    }
  },
  components: { HelpItem },
  data() {
    return {
      manifestoList: [],
      manifesto: {},
      total: 0,
      loading: false,
      finished: false,
      firendHelp: false,
      pageNumber: 1,
      pageSize: 5,
      taskSenderId: '', // 第一页第一条id
      giveLikeCount: 0,
      hasCloseTopTip: false,
      topTipShow: false,
      noLikeNumDialog: false,
    };
  },
  async created() {
    const app = document.querySelector('#app');
    app.scrollTop = 1;
    window.pageYoffset = 1;
    document.documentElement.scrollTop = 1;
    document.body.scrollTop = 1;
    await this.getTaskInfoById();
    // helpActivity页面活动图高度超过一屏时van-list不自动触发load
    this.manifestoList = [];
    this.pageNumber = 1;
    this.finished = false;
    this.loadList();
  },
  watch: {
    '$route.query.taskSenderId' () {
      this.manifestoList = [];
      this.pageNumber = 1;
      this.finished = false;
      this.loadList();
    },
    fatherGiveLikeCount () {
      this.giveLikeCount = this.fatherGiveLikeCount;
    }
  },
  methods: {
    handleCloseTopTip () {
      this.hasCloseTopTip = true;
      this.topTipShow = false;
    },
    hasNotLikeNum () {
      this.noLikeNumDialog = true;
    },
    hasLike (data) {
      this.$emit('listGiveLike');
      this.giveLikeCount--;
      if (this.giveLikeCount >= 0) {
        this.topTipShow = true;
        const index = this.manifestoList.findIndex(item => {
          return item.id === data.id;
        });
        this.$set(this.manifestoList[index], 'giveLikeGif', true);
        setTimeout(() => {
          this.manifestoList[index].giveLikeGif = false;
          this.manifestoList[index].isGiveLike = true;
        }, 420);
      }
    },
    async onLoad() {
      await this.loadList();
    },
    async loadList() {
      const postData = {
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        taskId: this.$route.query.taskId,
        taskSenderId: this.taskSenderId,
        excludeTaskSenderId: this.$route.name === 'HelpActivityEntry' ? '' : this.$route.query.taskSenderId,
      };
      const res = await listCompetitionWorks(postData);
      this.loading = false;
      if (res.data && res.data.errorCode == 200) {
        const data = res.data.data;
        this.total = data.total;
        if (data.current === 1) { // 传第一页第一条id，防止查询第二页数据时插入新活动
          if (data.records.length === 0) {
            this.finished = true;
          } else {
            // this.$emit('emitGiveLikeCountTotal', 1);
            this.$emit('emitGiveLikeCountTotal', data.giveLikeCountTotal);
            // this.giveLikeCount = 5 - 1;
            this.giveLikeCount = 5 - data.giveLikeCountTotal;
            this.taskSenderId = data.records[0].idStr;
            if (this.giveLikeCount > 0) {
              if (!this.hasCloseTopTip) { // 手动关闭以后触发打开
                this.topTipShow = true;
              }
            }
          }
        }
        if (this.pageNumber === 1) {
          this.manifestoList = [];
        }
        this.manifestoList = [...this.manifestoList, ...data.records];
        if (this.manifestoList.length >= this.total) {
          this.finished = true;
        } else {
          this.pageNumber++;
        }
      } else {
        this.finished = true;
      }
    },
    async getTaskInfoById () {
      const res = await getTaskInfoById({}, this.$route.query.taskId);
      if (res.data && res.data.errorCode == 200) {
        const data = res.data.data;
        if (data.status === 1) {
          this.$router.push({
            name: 'HelpActivityRankList',
            query: {
              activityId: this.$route.query.activityId,
              shareId: this.$route.query.shareId,
              taskId: this.$route.query.taskId,
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.background_image {
  background: #627fff url('../../assets/help-activity/entry_bg.png') 0 0 no-repeat;
  background-size: 100%;
  padding-top: 50px !important;
  min-height: 100%;
}
.top_tip_show {
  padding-top: 90px !important;
}
.all_help {
  transition: .3s;
  box-sizing: border-box;
  padding: 0 10px 20px;
  header {
    padding: 0 0 10px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #fff;
    letter-spacing: 1px;
    img {
      width: 18px;
      margin-top: 5px;
    }
    div {
      padding-left: 5px;
    }
  }
  .all_help_container {
    .all_help_item {
      margin-bottom: 20px;
    }
    /deep/ .van-list__finished-text {
      color: #fff;
    }
    /deep/ .van-loading__text {
      color: #fff;
    }
    /deep/ .van-loading {
      color: #fff;
    }
  }
}
.toActivity {
  display: block;
  text-align: center;
  padding: 0 0 30px;
  color: #0b0086;
  font-size: 14px;
  text-decoration: underline;
}
.empty {
  line-height: 100px;
  text-align: center;
  color: lightgray;
  font-size: 15px;
}
</style>